import { Request } from '../../Servidor/Request';

export class DengueStageRequest {
    private sgepfasedengue: number;
    private nome: string;

    constructor(sgepfasedengue: number, nome: string) {
        this.sgepfasedengue = sgepfasedengue;
        this.nome = nome;
    }


    /**
     * Getter sgepfasedengue
     * @return {number}
     */
    public getSgepfasedengue(): number {
        return this.sgepfasedengue;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getNome(): string {
        return this.nome;
    }
}

export class DengueStageStructRequest {
    private sgepfasedengue: number;

    constructor(sgepfasedengue: number) {
        this.sgepfasedengue = sgepfasedengue;
    }


    /**
     * Getter sgepfasedengue
     * @return {number}
     */
    public getSgepfasedengue(): number {
        return this.sgepfasedengue;
    }

}

export class DengueStageStructResponse {
    private sgepfasedengue: number;
    private nome: string;

    constructor(sgepfasedengue: number, nome: string) {
        this.sgepfasedengue = sgepfasedengue;
        this.nome = nome;
    }


    /**
     * Getter sgepfasedengue
     * @return {number}
     */
    public getSgepfasedengue(): number {
        return this.sgepfasedengue;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getNome(): string {
        return this.nome;
    }
}

export class DengueStageInteractor {
    public fetchSave(request: DengueStageRequest): PromiseLike<Boolean> {
        return new Promise((res, rej) => {
            return new Request().requestPost("basico/fase-dengue/salvar", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                let response = rs.Status == "Sucesso"
                res(response)
            }, e => {
                rej(e);
            });
        });
    }

    public fetchDataOne(request: DengueStageStructRequest): PromiseLike<DengueStageStructResponse> {
        return new Promise((res, rej) => {
            return new Request().requestPost("basico/fase-dengue/buscar", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
}